import React from 'react';

const SectionHeader = ({ title, subtitle, align = "center" }) => {
  return (
    <div 
      className={`mb-16 ${align === "left" ? "text-left" : "text-center"}`}
    >
      <h2 className="text-4xl md:text-5xl font-light tracking-tighter text-white mb-4 uppercase">{title}</h2>
      {subtitle && <div className="w-24 h-1 bg-gradient-to-r from-zinc-500 to-zinc-800 mx-auto mt-6"></div>}
      {subtitle && <p className="text-zinc-400 mt-6 max-w-2xl mx-auto font-light tracking-wide">{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;
